import { useParams } from 'react-router-dom';
import { useGetAMCLogsQuery, useGetAMCQuery } from '@/services';
import AuditHistory from '@/components/AuditHistory';

export default function AMCHistory() {
    const { id } = useParams<{ id: string }>();
    const { data: amc } = useGetAMCQuery(id!, { skip: !id });
    const { data, isLoading, error } = useGetAMCLogsQuery(id!, { skip: !id });

    return (
        <AuditHistory
            title="Company History"
            entityName={amc?.name}
            backLink={id ? {
                to: `/amcs/${id}`,
                label: 'Back to Company'
            } : undefined}
            data={data}
            isLoading={isLoading}
            error={error}
            emptyMessage="No history found."
        />
    );
}
